"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EEtatCompte = void 0;
exports.EEtatCompte = {
    actif: "actif",
    inactif: "inactif",
};
